// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".co-connect .co-payment+.co-connect__devices{margin-top:24px}.co-connect__devices{display:flex;flex-wrap:wrap;gap:16px}.co-connect__devices button{width:calc(33.33333% - 10.66667px)}.co-connect__title{color:#6c7684;font-size:16px;line-height:150%;margin-bottom:24px}.co-connect__title+.co-connect__devices{margin-top:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
